var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0F8FF8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10.6897L4.95563 9.5625H5.43769C5.4252 9.36963 5.41882 9.1764 5.41856 8.98313C5.41856 8.73113 5.42925 8.49713 5.45006 8.28H4.5L4.95563 7.15331H5.67225C6.33937 5.00962 7.8435 3.9375 10.1829 3.9375C10.9519 3.9375 11.6826 4.03706 12.375 4.23675V5.6565C11.7233 5.3653 11.0171 5.21649 10.3033 5.22C8.901 5.22 7.99931 5.86463 7.59769 7.15388H11.7731L11.3175 8.28056H7.32544C7.30153 8.46613 7.29101 8.65317 7.29394 8.84025C7.29394 9.10969 7.30238 9.35044 7.31925 9.56306H10.7972L10.3472 10.6897H7.56C7.85981 11.4711 8.22544 12.0144 8.65631 12.321C9.08663 12.627 9.70144 12.78 10.4996 12.78C11.07 12.78 11.6949 12.6411 12.375 12.3632V13.698C11.7287 13.941 10.9603 14.0625 10.0687 14.0625C7.72481 14.0625 6.24206 12.9381 5.62163 10.6897H4.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.8b981d8f8ad582ec2c217d6169edcee2.svg";
export { ForwardRef as ReactComponent };